import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isJoinPopupVisible: false,
  isServicesPopupVisible: false,
  selectedServiceOrder: 0,
  servicesPopupStyle: {},
  // Start transparent so the hero nav paints with no fill on first load
  // (avoids a one-frame flash of the dark/light glass capsule).
  navbarColor: "transparent",
  statusbarColor: "#292929",
  scrollPosition: 0,
};

const homeSlice = createSlice({
  name: "home_slice",
  initialState,
  reducers: {
    setIsJoinPopupVisible: (state) => {
      state.isJoinPopupVisible = !state.isJoinPopupVisible;
    },
    setIsServicesPopupVisible: (state) => {
      state.isServicesPopupVisible = !state.isServicesPopupVisible;
    },
    setSelectedServiceOrder: (state, action) => {
      state.selectedServiceOrder = action.payload;
    },
    setServicesPopupStyle: (state, action) => {
      state.servicesPopupStyle = action.payload;
    },
    setNavbarColor: (state, action) => {
      state.navbarColor = action.payload;
    },
    setStatusbarColor: (state, action) => {
      state.statusbarColor = action.payload;
    },
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
  },
});

export default homeSlice.reducer;



export const {
  setIsJoinPopupVisible,
  setIsServicesPopupVisible,
  setSelectedServiceOrder,
  setServicesPopupStyle,
  setNavbarColor,
  setStatusbarColor,
  setScrollPosition,
} = homeSlice.actions;

export const homeSelector= store => store.home




 